import React from 'react'
import PropTypes from 'prop-types'

export default function OrderConfirmed({ day, isSubmitted = false }) {
  return (
    <div>
      <div className="row-bot">
        <div className="text-border">
          <span>ORDER CONFIRMED{isSubmitted ? ' (SUBMITTED)' : ''}<br /><b>Pick Up in {day} Days Time</b>
          </span>
        </div>
      </div>
    </div>
  )
}

OrderConfirmed.propTypes = {
  day: PropTypes.number,
  isSubmitted: PropTypes.bool,
}
